import { FC } from 'react'

import styles from './new-code-btn.module.scss'

interface INewCodeBtn {
  onClick: () => void
}

const NewCodeBtn: FC<INewCodeBtn> = ({ onClick }) => {
  return (
    <div className={styles.btn} onClick={onClick}>
      Получить новый код
    </div>
  )
}

export default NewCodeBtn
